import React__default, { createElement, useState, useReducer, useRef, useEffect, Fragment } from 'react';
import require$$0 from 'util';
import ReactDOM from 'react-dom';

var Theme;
(function (Theme) {
    Theme["BLACK"] = "black";
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
})(Theme || (Theme = {}));
var PageID;
(function (PageID) {
    PageID["CART"] = "CART";
    PageID["CHECKOUT"] = "CHECKOUT";
    PageID["IDP_WIRELESS"] = "IDP_WIRELESS";
    PageID["IDP_WIRELESS_CONFIG"] = "IDP_WIRELESS_CONFIG";
    PageID["PDP"] = "PDP";
    PageID["PLP"] = "PLP";
    PageID["PSC"] = "PSC";
    PageID["PSC_CONFIG"] = "PSC_CONFIG";
    PageID["PSC_HUB"] = "PSC_HUB";
    PageID["PSC_LEARN"] = "PSC_LEARN";
    PageID["PSC_LEARN_BYOD"] = "PSC_LEARN_BYOD";
    PageID["PSC_LINE_SELECTION"] = "PSC_LINE_SELECTION";
    PageID["TOKENLANDER"] = "TOKENLANDER";
    PageID["UF"] = "UF";
    PageID["WIRELINE"] = "WIRELINE";
    PageID["WLNUF"] = "WLNUF";
    PageID["WLSUF"] = "WLSUF";
})(PageID || (PageID = {}));
var OfferType;
(function (OfferType) {
    OfferType["Signature"] = "signature";
    OfferType["Signature_Private"] = "signature,private";
    OfferType["Private"] = "private";
})(OfferType || (OfferType = {}));
var AccentStripeColor;
(function (AccentStripeColor) {
    AccentStripeColor["BLUE"] = "Blue";
    AccentStripeColor["LIME"] = "Lime";
    AccentStripeColor["PURPLE"] = "Purple";
})(AccentStripeColor || (AccentStripeColor = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var toStr = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr$1 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$1.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$1.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation = keysShim;

var slice = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) { return origKeys(o); } : implementation;

var originalKeys = Object.keys;

keysShim$1.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim$1;
	}
	return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$2 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$2.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice$1.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice$1.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice$1.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$1 = hasSymbols();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$1 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$1 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$1 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$1 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$1 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);
var $exec = functionBind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var $defineProperty = getIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors;

var hasSymbols$2 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$3 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr$3.call(fn) === '[object Function]';
};

var hasPropertyDescriptors$1 = hasPropertyDescriptors_1();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors$1;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$2) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError$1 = TypeError;

var esShimUnscopables = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError$1('method must be a non-empty string');
	}
	if (!src(Array.prototype, method)) {
		throw new $TypeError$1('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map[method] = true;
	}
};

var $abs = getIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

var abs = function abs(x) {
	return $abs(x);
};

// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

var floor = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};

// https://262.ecma-international.org/5.1/#sec-8

var Type = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type$1(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return Type(x);
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };

// https://tc39.es/ecma262/#sec-isintegralnumber

var IsIntegralNumber = function IsIntegralNumber(argument) {
	if (Type$1(argument) !== 'Number' || _isNaN(argument) || !_isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};

var $ArrayPrototype = getIntrinsic('%Array.prototype%');
var $RangeError = getIntrinsic('%RangeError%');
var $SyntaxError$1 = getIntrinsic('%SyntaxError%');
var $TypeError$2 = getIntrinsic('%TypeError%');



var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = getIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

var ArrayCreate = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$2('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError$1('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};

var util_inspect = require$$0.inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat$1 = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor$1 = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable$1 = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor$1(-num) : $floor$1(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace$1.call(intStr, sepRegex, '$&_') + '.' + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace$1.call(str, sepRegex, '$&_');
}


var inspectCustom = util_inspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$1(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable$1.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat$1.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && util_inspect) {
            return util_inspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$4(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat$1.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace$1.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr$4(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr$4(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$4(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$4(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr$4(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr$4(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr$4(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$4(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace$1.call($replace$1.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable$1.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

var $TypeError$3 = getIntrinsic('%TypeError%');






// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

var Get = function Get(O, P) {
	// 7.3.1.1
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$3('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$3('Assertion failed: IsPropertyKey(P) is not true, got ' + objectInspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var $Array = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$5 = !$Array.isArray && callBound('Object.prototype.toString');

var IsArray = $Array.isArray || function IsArray(argument) {
	return toStr$5(argument) === '[object Array]';
};

// https://ecma-international.org/ecma-262/6.0/#sec-isarray
var IsArray$1 = IsArray;

// TODO: remove, semver-major

var GetIntrinsic = getIntrinsic;

var $TypeError$4 = getIntrinsic('%TypeError%');

var isPropertyDescriptor = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (src(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError$4('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var $defineProperty$1 = hasPropertyDescriptors_1() && getIntrinsic('%Object.defineProperty%', true);

var hasArrayLengthDefineBug = hasPropertyDescriptors_1.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray$1 = hasArrayLengthDefineBug && IsArray;



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty$1) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray$1(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty$1(O, P, FromPropertyDescriptor(desc));
	return true;
};

// https://262.ecma-international.org/13.0/#sec-match-records

var isMatchRecord = function isMatchRecord(record) {
	return (
		src(record, '[[StartIndex]]')
        && src(record, '[[EndIndex]]')
        && record['[[StartIndex]]'] >= 0
        && record['[[EndIndex]]'] >= record['[[StartIndex]]']
        && String(parseInt(record['[[StartIndex]]'], 10)) === String(record['[[StartIndex]]'])
        && String(parseInt(record['[[EndIndex]]'], 10)) === String(record['[[EndIndex]]'])
	);
};

var $TypeError$5 = getIntrinsic('%TypeError%');
var $SyntaxError$2 = getIntrinsic('%SyntaxError%');





var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Desc) {
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$5('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},
	// https://262.ecma-international.org/13.0/#sec-match-records
	'Match Record': isMatchRecord
};

var assertRecord = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError$2('unknown record type: ' + recordType);
	}
	if (Type(value) !== 'Object' || !predicate(value)) {
		throw new $TypeError$5(argumentName + ' must be a ' + recordType);
	}
};

var fromPropertyDescriptor = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined') {
		assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);
	}

	return fromPropertyDescriptor(Desc);
};

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

var IsAccessorDescriptor = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type$1, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://262.ecma-international.org/5.1/#sec-9.12

var SameValue = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return _isNaN(x) && _isNaN(y);
};

// http://262.ecma-international.org/5.1/#sec-9.2

var ToBoolean = function ToBoolean(value) { return !!value; };

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$6 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

var isCallable = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$6.call(value);
		return strClass === fnClass || strClass === genClass;
	};

// http://262.ecma-international.org/5.1/#sec-9.11

var IsCallable = isCallable;

var $TypeError$6 = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/5.1/#sec-8.10.5

var ToPropertyDescriptor = function ToPropertyDescriptor(Obj) {
	if (Type$1(Obj) !== 'Object') {
		throw new $TypeError$6('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError$6('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$6('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$6('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var $TypeError$7 = getIntrinsic('%TypeError%');












// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$7('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError$7('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type$1,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError$7('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var IsConstructor = createCommonjsModule(function (module) {



var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow$1 = DefinePropertyOrThrow;
try {
	DefinePropertyOrThrow$1({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow$1 = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow$1 && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow$1(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var $species = getIntrinsic('%Symbol.species%', true);
var $TypeError$8 = getIntrinsic('%TypeError%');








// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

var ArraySpeciesCreate = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$8('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray$1(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type$1(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$8('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};

var $Math = getIntrinsic('%Math%');
var $Number = getIntrinsic('%Number%');

var maxSafeInteger = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

var $TypeError$9 = getIntrinsic('%TypeError%');



var $apply = getIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

var Call = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray$1(argumentsList)) {
		throw new $TypeError$9('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

var $gOPD$1 = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var getOwnPropertyDescriptor = $gOPD$1;

var shams$1 = function hasToStringTagShams() {
	return shams() && !!Symbol.toStringTag;
};

var hasToStringTag$1 = shams$1();
var has$2;
var $exec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
	has$2 = callBound('Object.prototype.hasOwnProperty');
	$exec$1 = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$1
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$2(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};

var $match$1 = getIntrinsic('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match$1) {
		var isRegExp = argument[$match$1];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $TypeError$a = getIntrinsic('%TypeError%');



var $isEnumerable$1 = callBound('Object.prototype.propertyIsEnumerable');









// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty = function OrdinaryGetOwnProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$a('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$a('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!getOwnPropertyDescriptor) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray$1(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable$1(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor(getOwnPropertyDescriptor(O, P));
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var $preventExtensions = getIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = getIntrinsic('%Object.isExtensible%', true);



// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};

var $TypeError$b = getIntrinsic('%TypeError%');











// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty = function CreateDataProperty(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$b('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$b('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var nonConfigurable = oldDesc && !oldDesc['[[Configurable]]'];
	if (nonConfigurable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var $TypeError$c = getIntrinsic('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$c('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$c('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$c('unable to create data property');
	}
	return success;
};

var $TypeError$d = getIntrinsic('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty = function HasProperty(O, P) {
	if (Type$1(O) !== 'Object') {
		throw new $TypeError$d('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$d('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var $exec$2 = callBound('RegExp.prototype.exec');

var regexTester = function regexTester(regex) {
	return function test(s) { return $exec$2(regex, s) !== null; };
};

var isPrimitive$1 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$7 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = shams$1();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$2 ? tryDateObject(value) : toStr$7.call(value) === dateClass;
};

var isSymbol$1 = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols$1 = hasSymbols();

if (hasSymbols$1) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive$1(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive$1(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols$3) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol$1(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive$1(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol$1(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var $TypeError$e = getIntrinsic('%TypeError%');
var $Number$1 = getIntrinsic('%Number%');
var $RegExp = getIntrinsic('%RegExp%');
var $parseInteger = getIntrinsic('%parseInt%');





var $strSlice$1 = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace$2 = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace$2(value, trimRegex, '');
};



// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number$1);
	if (typeof value === 'symbol') {
		throw new $TypeError$e('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError$e('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice$1(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice$1(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number$1(value);
};

var sign = function sign(number) {
	return number >= 0 ? 1 : -1;
};

// https://262.ecma-international.org/12.0/#sec-tointegerorinfinity

var ToIntegerOrInfinity = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if (_isNaN(number) || number === 0) { return 0; }
	if (!_isFinite(number)) { return number; }
	return sign(number) * floor(abs(number));
};

var ToLength = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > maxSafeInteger) { return maxSafeInteger; }
	return len;
};

var $TypeError$f = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

var LengthOfArrayLike = function LengthOfArrayLike(obj) {
	if (Type$1(obj) !== 'Object') {
		throw new $TypeError$f('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

var $String = getIntrinsic('%String%');
var $TypeError$g = getIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$g('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var $TypeError$h = getIntrinsic('%TypeError%');











// https://262.ecma-international.org/11.0/#sec-flattenintoarray

// eslint-disable-next-line max-params
var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError$h('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray$1(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= maxSafeInteger) {
					throw new $TypeError$h('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

var $TypeError$i = getIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError$i(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var RequireObjectCoercible = CheckObjectCoercible;

var $Object = getIntrinsic('%Object%');



// https://ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};

var implementation$2 = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill = function getPolyfill() {
	return Array.prototype.flat || implementation$2;
};

var shim = function shimFlat() {
	var polyfill$1 = polyfill();

	defineProperties_1(
		Array.prototype,
		{ flat: polyfill$1 },
		{ flat: function () { return Array.prototype.flat !== polyfill$1; } }
	);

	esShimUnscopables('flat');

	return polyfill$1;
};

shim();

var FlatFilter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatfiltermap = exports.filtermap = exports.flatfilter = exports.flatmap = exports.flat = exports.map = exports.filter = exports.assertType = void 0;
/** Asserts the type of obj at compile-time */
function assertType(_obj) {
    return;
}
exports.assertType = assertType;
function wrap(array) {
    return Array.isArray(array) ? array : [array];
}
function filter(array) {
    return wrap(array).filter(Boolean);
}
exports.filter = filter;
function map(array, mapper) {
    return wrap(array).map(mapper);
}
exports.map = map;
function flat(array) {
    return wrap(array).flat(Infinity);
}
exports.flat = flat;
function flatmap(array, mapper) {
    return map(flat(array), mapper);
}
exports.flatmap = flatmap;
function flatfilter(array) {
    return filter(flat(array));
}
exports.flatfilter = flatfilter;
function filtermap(array, mapper) {
    return filter(map(array, mapper));
}
exports.filtermap = filtermap;
function flatfiltermap(array, mapper) {
    return filtermap(flat(array), mapper);
}
exports.flatfiltermap = flatfiltermap;
});

var Join = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;

/** Create a single CSS class from a set of classes or conditional classes. */
function join() {
    var potentials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        potentials[_i] = arguments[_i];
    }
    // Edge is stubborn and adds commas anyways. Let's replace them with spaces.
    return FlatFilter.flatfilter(potentials)
        .join(" ")
        .replace(/,/g, " ");
}
exports.join = join;
});

var Collapse_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });


/**
 * A generic collapse that can hide or show content with animation.
 */
var Collapse = function (_a) {
    var _b, _c;
    var _d = _a.expanded, expanded = _d === void 0 ? false : _d, labelledbyId = _a.labelledbyId, _e = _a.immediate, immediate = _e === void 0 ? false : _e, style = _a.style, className = _a.className, wrapperClassName = _a.wrapperClassName, wrapperStyle = _a.wrapperStyle, children = _a.children, testId = _a.testId;
    var _f = __read(React__default.useState({
        oriantationChanged: true,
    }), 2), state = _f[0], setState = _f[1];
    React__default.useEffect(function () {
        window.addEventListener("orientationchange", function (e) {
            e.stopPropagation();
            setTimeout(function () {
                setState({ oriantationChanged: !state.oriantationChanged });
            }, 10);
        });
    }, []);
    var wrapper = React__default.useRef(null);
    var expStyle = !immediate ? {
        maxHeight: expanded ? (((_b = wrapper.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + "px") : "0px",
        transition: "max-height 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95)",
    } :
        {
            maxHeight: expanded ? (((_c = wrapper.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) + "px") : "0px",
        };
    return (React__default.createElement("div", { "data-testid": testId, style: __assign(__assign({}, expStyle), wrapperStyle), className: Join.join("rel", "overflow-hidden", wrapperClassName), "aria-labelledby": labelledbyId, role: "region" },
        React__default.createElement("div", { ref: wrapper, style: style, className: Join.join(className, "rel") }, children)));
};
exports.default = Collapse;
});

var CollapseProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var Collapse = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });

__exportStar(Collapse_1, exports);
__exportStar(CollapseProps, exports);
exports.default = Collapse_1.default;
});

var Collapse$1 = /*@__PURE__*/getDefaultExportFromCjs(Collapse);

var utils = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSsrSafe = exports.ssrSafe = exports.isMobile = void 0;
/**
 * @param {string} parentTestId testId of parent component
 * @param {string} component Callee component's definition. Ex: Button
 * @param {string} testIdSuffix Describes callee component's feature/property. Ex: SelectPrice
 */
function getTestId(parentTestId, component, testIdSuffix) {
    return parentTestId
        ? parentTestId + "_" + component + (testIdSuffix ? "_" + testIdSuffix : "")
        : "";
}
exports.default = getTestId;
function isMobile() {
    if (process.browser) {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobile = isMobile;
/**
 * Run a function if it is safe to do so when taking SSR into account.
 * @param func The function to run if it is safe to do so.
 * @param dependencies Any extra dependencies to check.
 */
function ssrSafe(func, dependencies) {
    if (dependencies === void 0) { dependencies = [
        (typeof process === "object" && process.browser) || typeof window === "object",
    ]; }
    // ensures browser specific functions are run only if browser is available whether in ssr or client
    if (dependencies.every(Boolean)) {
        return func();
    }
    return undefined;
}
exports.ssrSafe = ssrSafe;
function makeSsrSafe(func, dependencies) {
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ssrSafe(function () {
            var _a;
            return (_a = func).call.apply(_a, __spread([_this], args));
        }, dependencies);
    };
}
exports.makeSsrSafe = makeSsrSafe;
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var nModal = "SimpleModal_nModal__swAcl";
var nModalContent = "SimpleModal_nModalContent__oto3S";
var nModalSm = "SimpleModal_nModalSm__XwfWc";
var nModalMd = "SimpleModal_nModalMd__ePPr1";
var nModalLg = "SimpleModal_nModalLg__uR2y1";
var nModalXLg = "SimpleModal_nModalXLg__usqV9";
var nModalSt = "SimpleModal_nModalSt__AeX8C";
var nModalFs = "SimpleModal_nModalFs__HDkaz";
var nModalNormal = "SimpleModal_nModalNormal__waH-O";
var nModalFull = "SimpleModal_nModalFull__nbI3j";
var nCloseButton = "SimpleModal_nCloseButton__pP4J8";
var nClose = "SimpleModal_nClose__Wqu34";
var nModalOverylayClose = "SimpleModal_nModalOverylayClose__yvBNX";
var nModalOverylayOpen = "SimpleModal_nModalOverylayOpen__QJEUF";
var css_248z = ".SimpleModal_nModal__swAcl {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.85); }\n\n/* Modal Content */\n.SimpleModal_nModalContent__oto3S {\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  min-height: 100px;\n  max-height: 100%;\n  border-radius: 3px;\n  z-index: 1001; }\n\n/* Modal Sizes */\n.SimpleModal_nModalSm__XwfWc {\n  max-width: 400px; }\n\n.SimpleModal_nModalMd__ePPr1 {\n  max-width: 560px; }\n\n.SimpleModal_nModalLg__uR2y1 {\n  max-width: 720px; }\n\n.SimpleModal_nModalXLg__usqV9 {\n  max-width: 960px; }\n\n.SimpleModal_nModalSt__AeX8C {\n  max-width: none; }\n\n.SimpleModal_nModalFs__HDkaz {\n  height: 100vh;\n  width: 100vw;\n  border-radius: 0px; }\n\n.SimpleModal_nModalNormal__waH-O {\n  max-height: 90vh; }\n\n@media (max-width: 1020px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalXLg__usqV9 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 960px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalXLg__usqV9 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 780px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalLg__uR2y1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 720px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalLg__uR2y1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 620px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalMd__ePPr1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 560px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalMd__ePPr1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 460px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalSm__XwfWc {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 400px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalSm__XwfWc {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n/* The Close Button */\n.SimpleModal_nCloseButton__pP4J8 {\n  border: none;\n  border-radius: 50%;\n  font-size: 10px !important;\n  right: 16px;\n  top: 16px;\n  height: 24px;\n  width: 24px; }\n  .SimpleModal_nCloseButton__pP4J8 .SimpleModal_nClose__Wqu34 {\n    fill: #1d2329;\n    height: 24px; }\n\n.SimpleModal_nCloseButton__pP4J8:focus {\n  outline: 2px solid #0057b8; }\n\n.SimpleModal_nCloseButton__pP4J8:hover .SimpleModal_nClose__Wqu34 {\n  fill: #686e74; }\n\n.SimpleModal_nModalOverylayClose__yvBNX {\n  opacity: 0;\n  transition: opacity ease-in-out 450ms; }\n\n.SimpleModal_nModalOverylayOpen__QJEUF {\n  opacity: 1;\n  transition: opacity ease-in-out 450ms; }\n";
var SimpleModal = {"nModal":"SimpleModal_nModal__swAcl","nModalContent":"SimpleModal_nModalContent__oto3S","nModalSm":"SimpleModal_nModalSm__XwfWc","nModalMd":"SimpleModal_nModalMd__ePPr1","nModalLg":"SimpleModal_nModalLg__uR2y1","nModalXLg":"SimpleModal_nModalXLg__usqV9","nModalSt":"SimpleModal_nModalSt__AeX8C","nModalFs":"SimpleModal_nModalFs__HDkaz","nModalNormal":"SimpleModal_nModalNormal__waH-O","nModalFull":"SimpleModal_nModalFull__nbI3j","nCloseButton":"SimpleModal_nCloseButton__pP4J8","nClose":"SimpleModal_nClose__Wqu34","nModalOverylayClose":"SimpleModal_nModalOverylayClose__yvBNX","nModalOverylayOpen":"SimpleModal_nModalOverylayOpen__QJEUF"};
var stylesheet=".SimpleModal_nModal__swAcl {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.85); }\n\n/* Modal Content */\n.SimpleModal_nModalContent__oto3S {\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  min-height: 100px;\n  max-height: 100%;\n  border-radius: 3px;\n  z-index: 1001; }\n\n/* Modal Sizes */\n.SimpleModal_nModalSm__XwfWc {\n  max-width: 400px; }\n\n.SimpleModal_nModalMd__ePPr1 {\n  max-width: 560px; }\n\n.SimpleModal_nModalLg__uR2y1 {\n  max-width: 720px; }\n\n.SimpleModal_nModalXLg__usqV9 {\n  max-width: 960px; }\n\n.SimpleModal_nModalSt__AeX8C {\n  max-width: none; }\n\n.SimpleModal_nModalFs__HDkaz {\n  height: 100vh;\n  width: 100vw;\n  border-radius: 0px; }\n\n.SimpleModal_nModalNormal__waH-O {\n  max-height: 90vh; }\n\n@media (max-width: 1020px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalXLg__usqV9 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 960px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalXLg__usqV9 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 780px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalLg__uR2y1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 720px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalLg__uR2y1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 620px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalMd__ePPr1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 560px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalMd__ePPr1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 460px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalSm__XwfWc {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 400px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalSm__XwfWc {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n/* The Close Button */\n.SimpleModal_nCloseButton__pP4J8 {\n  border: none;\n  border-radius: 50%;\n  font-size: 10px !important;\n  right: 16px;\n  top: 16px;\n  height: 24px;\n  width: 24px; }\n  .SimpleModal_nCloseButton__pP4J8 .SimpleModal_nClose__Wqu34 {\n    fill: #1d2329;\n    height: 24px; }\n\n.SimpleModal_nCloseButton__pP4J8:focus {\n  outline: 2px solid #0057b8; }\n\n.SimpleModal_nCloseButton__pP4J8:hover .SimpleModal_nClose__Wqu34 {\n  fill: #686e74; }\n\n.SimpleModal_nModalOverylayClose__yvBNX {\n  opacity: 0;\n  transition: opacity ease-in-out 450ms; }\n\n.SimpleModal_nModalOverylayOpen__QJEUF {\n  opacity: 1;\n  transition: opacity ease-in-out 450ms; }\n";
styleInject(css_248z);

var SimpleModal$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    nModal: nModal,
    nModalContent: nModalContent,
    nModalSm: nModalSm,
    nModalMd: nModalMd,
    nModalLg: nModalLg,
    nModalXLg: nModalXLg,
    nModalSt: nModalSt,
    nModalFs: nModalFs,
    nModalNormal: nModalNormal,
    nModalFull: nModalFull,
    nCloseButton: nCloseButton,
    nClose: nClose,
    nModalOverylayClose: nModalOverylayClose,
    nModalOverylayOpen: nModalOverylayOpen,
    'default': SimpleModal,
    stylesheet: stylesheet
});

var SimpleModalProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModalSize = exports.SimpleModalSizing = void 0;
var SimpleModalSizing;
(function (SimpleModalSizing) {
    SimpleModalSizing["NORMAL"] = "normal";
    SimpleModalSizing["FULL"] = "full";
})(SimpleModalSizing = exports.SimpleModalSizing || (exports.SimpleModalSizing = {}));
var SimpleModalSize;
(function (SimpleModalSize) {
    SimpleModalSize["SMALL"] = "small";
    SimpleModalSize["MEDIUM"] = "medium";
    SimpleModalSize["LARGE"] = "large";
    SimpleModalSize["EXTRA_LARGE"] = "extralarge";
    SimpleModalSize["SHEET"] = "sheet";
    SimpleModalSize["FULL_SCREEN"] = "fullscreen";
})(SimpleModalSize = exports.SimpleModalSize || (exports.SimpleModalSize = {}));
});

var styles = /*@__PURE__*/getAugmentedNamespace(SimpleModal$1);

var SimpleModalStylesMaps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizingMap = exports.sizeMap = void 0;


exports.sizeMap = new Map([
    [SimpleModalProps.SimpleModalSize.SMALL, styles.nModalSm],
    [SimpleModalProps.SimpleModalSize.MEDIUM, styles.nModalMd],
    [SimpleModalProps.SimpleModalSize.LARGE, styles.nModalLg],
    [SimpleModalProps.SimpleModalSize.EXTRA_LARGE, styles.nModalXLg],
    [SimpleModalProps.SimpleModalSize.SHEET, styles.nModalSt],
    [SimpleModalProps.SimpleModalSize.FULL_SCREEN, styles.nModalFs],
]);
exports.sizingMap = new Map([
    [SimpleModalProps.SimpleModalSizing.NORMAL, styles.nModalNormal],
    [SimpleModalProps.SimpleModalSizing.FULL, styles.nModalFull],
]);
});

var SimpleModal_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });






var SimpleModal = /** @class */ (function (_super) {
    __extends(SimpleModal, _super);
    function SimpleModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabElements = null;
        _this.firstEl = null;
        _this.lastEl = null;
        _this.previousEl = null;
        _this.state = {
            escaped: false,
            shown: false,
            transition: _this.props.show ? styles.nModalOverylayOpen : styles.nModalOverylayClose,
            transitioning: false,
        };
        _this.addEscapeListener = function () {
            utils.ssrSafe(function () {
                if (window && window.addEventListener) {
                    window.addEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.removeEscapeListener = function () {
            utils.ssrSafe(function () {
                if (window && window.removeEventListener) {
                    window.removeEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.componentWillUnmount = function () {
            utils.ssrSafe(function () {
                if (document && document.documentElement) {
                    document.documentElement.classList.remove("overflow-hidden");
                }
                _this.removeEscapeListener();
            });
            _this.removeFocusListener();
        };
        _this.componentDidUpdate = function () {
            var _a = _this.props, disableOnFocus = _a.disableOnFocus, fade = _a.fade, focusFirstElement = _a.focusFirstElement, show = _a.show;
            var _b = _this.state, escaped = _b.escaped, shown = _b.shown, transition = _b.transition, transitioning = _b.transitioning;
            if (fade && show && !shown && transition !== styles.nModalOverylayOpen) {
                _this.setState({ transition: styles.nModalOverylayClose, transitioning: true });
            }
            if (fade && show && transitioning && transition === styles.nModalOverylayClose) {
                _this.setState({ transition: styles.nModalOverylayOpen });
            }
            if (escaped) {
                _this.onClose();
            }
            if (show && _this.containerRef && !escaped) {
                if (_this.modalRef) {
                    _this.tabElements = _this.modalRef.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
                    _this.firstEl = _this.tabElements[0];
                    _this.lastEl = _this.tabElements[_this.tabElements.length - 1];
                    if (!shown) {
                        if (disableOnFocus !== true) {
                            _this.addFocusListener();
                        }
                        else {
                            _this.removeFocusListener();
                        }
                    }
                    if (!shown && !transitioning) {
                        if (focusFirstElement && _this.firstEl) {
                            _this.firstEl.focus();
                        }
                        else {
                            _this.containerRef.focus();
                        }
                        _this.setState({ shown: true });
                    }
                }
            }
        };
        _this.addFocusListener = function () {
            utils.ssrSafe(function () {
                if (document && document.addEventListener) {
                    document.addEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.removeFocusListener = function () {
            utils.ssrSafe(function () {
                if (document && document.addEventListener) {
                    document.removeEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.onFocus = function (e) {
            var _a;
            var disableOnFocus = _this.props.disableOnFocus;
            if (disableOnFocus !== true) {
                var c_1 = false;
                if (_this.tabElements) {
                    _this.tabElements.forEach(function (item) {
                        if (item === e.target) {
                            item.focus();
                            _this.previousEl = item;
                            c_1 = true;
                            return;
                        }
                    });
                    if (!c_1 && e.target !== _this.containerRef && !((_a = _this.containerRef) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                        if (_this.previousEl === _this.firstEl) {
                            _this.lastEl.focus();
                        }
                        else {
                            _this.firstEl.focus();
                        }
                    }
                }
            }
        };
        _this.onTab = function (e, ref, shift) {
            if (e.which === 9 && shift) {
                e.preventDefault();
                ref.focus();
            }
        };
        _this.onClose = function (e) {
            _this.removeFocusListener();
            _this.setState({
                shown: false,
                transition: styles.nModalOverylayClose,
                transitioning: _this.props.fade ? true : false,
                escaped: false,
            });
            if (_this.wasFocused) {
                _this.wasFocused.focus();
                _this.wasFocused = undefined;
            }
            var close = _this.props.close;
            if (close) {
                close(e);
            }
        };
        _this.onEscape = function (e) {
            var noEscape = _this.props.noEscape;
            if (!noEscape && e.key === "Escape") {
                _this.setState({ escaped: true });
            }
        };
        _this.childClick = function (e) {
            e.stopPropagation();
        };
        _this.handleTransEnd = function () {
            _this.setState({ transitioning: false });
        };
        _this.render = function () {
            var _a = _this.props, accessibilityTitle = _a.accessibilityTitle, children = _a.children, closeButtonAccessibilityText = _a.closeButtonAccessibilityText, closeButtonClass = _a.closeButtonClass, closeHidden = _a.closeHidden, containerClass = _a.containerClass, contentClass = _a.contentClass, describedbyId = _a.describedbyId, fade = _a.fade, labelledbyId = _a.labelledbyId, propsRoot = _a.root, show = _a.show, propsSize = _a.size, propsSizing = _a.sizing, testId = _a.testId;
            utils.ssrSafe(function () {
                var _a = _this.state, escaped = _a.escaped, shown = _a.shown;
                if (document && document.documentElement && document.getElementById) {
                    var root = document.getElementById(propsRoot ? propsRoot : "root");
                    if (show) {
                        if (!_this.wasFocused) {
                            _this.wasFocused = document.activeElement || undefined;
                        }
                        if (root) {
                            root.setAttribute("aria-hidden", "true");
                        }
                        document.documentElement.classList.add("overflow-hidden");
                        if (!shown && !escaped) {
                            _this.addEscapeListener();
                        }
                    }
                    else {
                        if (_this.wasFocused) {
                            _this.wasFocused.focus();
                            _this.wasFocused = undefined;
                        }
                        if (root) {
                            root.removeAttribute("aria-hidden");
                        }
                        document.documentElement.classList.remove("overflow-hidden");
                        _this.removeEscapeListener();
                    }
                }
            });
            var _b = _this.state, transition = _b.transition, transitioning = _b.transitioning;
            var size = propsSize ? propsSize : SimpleModalProps.SimpleModalSize.MEDIUM;
            var sizing = propsSizing ? propsSizing : undefined;
            var renderModal = function () {
                return ((show || transitioning) && (React__default.createElement("div", { "data-testid": testId, onMouseDown: _this.onClose, onTransitionEnd: fade ? _this.handleTransEnd : undefined, ref: function (ref) {
                        _this.modalRef = ref;
                    }, className: [
                        fade ? transition : "",
                        containerClass,
                        styles.nModal,
                        "height-full left top block",
                    ].join(" ") },
                    React__default.createElement("div", { "aria-modal": true, tabIndex: -1, "aria-labelledby": labelledbyId, "aria-describedby": describedbyId, "aria-label": accessibilityTitle, role: "dialog", onMouseDown: _this.childClick, ref: function (ref) {
                            _this.containerRef = ref;
                        }, className: [
                            _this.getSizing(sizing),
                            contentClass,
                            _this.getSize(size),
                            styles.nModalContent,
                            "overflow-y-auto overflow-hidden rel bg-ui-white",
                        ].join(" ") },
                        !closeHidden && (React__default.createElement("button", { type: "button", "aria-label": closeButtonAccessibilityText || 'Close', onClick: _this.onClose, name: "close", className: [
                                "min-width-sm-all pad-none-all icon-close absolute color-ui-black",
                                closeButtonClass,
                                styles.nCloseButton,
                                "bg-ui-white absolute bg-ui-white",
                            ].join(" ") })),
                        children))));
            };
            if (typeof document !== "undefined") {
                return ReactDOM.createPortal(renderModal(), document.body);
            }
            return renderModal();
        };
        return _this;
    }
    SimpleModal.prototype.getSize = function (size) {
        if (size) {
            return SimpleModalStylesMaps.sizeMap.get(size);
        }
    };
    SimpleModal.prototype.getSizing = function (sizing) {
        if (sizing) {
            return SimpleModalStylesMaps.sizingMap.get(sizing);
        }
    };
    return SimpleModal;
}(React__default.Component));
exports.default = SimpleModal;
});

var SimpleModal$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = SimpleModal_1.default;
});

var SimpleModal$3 = /*@__PURE__*/getDefaultExportFromCjs(SimpleModal$2);

var css_248z$1 = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n[class=\"svg-base\"] {\n  fill: currentColor !important; }\n\n:not([class*=\"color-\"]) [class=\"svg-accent\"] {\n  fill: currentColor; }\n\n[class*=\"svg-accent-att-blue\"] [class=\"svg-accent\"] {\n  fill: #009fdb; }\n";
styleInject(css_248z$1);

var IconSvg_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });


var IconSvg = /** @class */ (function (_super) {
    __extends(IconSvg, _super);
    function IconSvg(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var svgUrl = _this.props.svgUrl;
            if (svgUrl) {
                _this.getIconFromUrl();
            }
        };
        _this.getIconFromUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var svgUrl, response, svgMarkUp, svgContent, viewBoxVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        svgUrl = this.props.svgUrl;
                        return [4 /*yield*/, fetch(svgUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgMarkUp = _a.sent();
                        svgContent = this.getIconContent(svgMarkUp);
                        viewBoxVal = this.getViewBoxVal(svgMarkUp);
                        this.setState({ svgContent: svgContent, viewBoxVal: viewBoxVal });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderIconFromStr = function () {
            var svgNodeStr = _this.props.svgNodeStr;
            if (svgNodeStr) {
                var svgContent = _this.getIconContent(svgNodeStr);
                var viewBoxVal = _this.getViewBoxVal(svgNodeStr);
                return _this.renderSvg(svgContent, viewBoxVal);
            }
            return null;
        };
        _this.getIconContent = function (svgNode) {
            var trimmedStr = svgNode.trim();
            var index = trimmedStr.indexOf("><");
            var returnStr = trimmedStr.substring(index + 1, trimmedStr.length - 6);
            return returnStr;
        };
        _this.getViewBoxVal = function (svgFromSource) {
            var splitA = svgFromSource.split('viewBox="');
            var splitB = splitA[1].split('"');
            var viewBoxVal = splitB[0];
            return viewBoxVal;
        };
        _this.renderSvg = function (svgContent, viewBoxVal) {
            var _a = _this.props, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, className = _a.className, colorClass = _a.colorClass, pictogramAccent = _a.pictogramAccent, pictogramDarkBg = _a.pictogramDarkBg, size = _a.size;
            var iconClass = colorClass;
            if (pictogramAccent) {
                iconClass = "svg-accent-att-blue " + (pictogramDarkBg ? "color-ui-white" : "color-black");
            }
            return (React__default.createElement("svg", { "aria-hidden": ariaHidden !== false, "aria-label": ariaHidden !== false ? undefined : ariaLabel, className: "inline-block " + iconClass + (className ? " " + className : ""), focusable: !(ariaHidden !== false), role: ariaHidden !== false ? undefined : "img", height: size ? size + "px" : undefined, width: size ? size + "px" : undefined, viewBox: viewBoxVal, dangerouslySetInnerHTML: {
                    __html: svgContent,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, svgNodeStr = _a.svgNodeStr, svgUrl = _a.svgUrl;
            if (svgUrl) {
                var _b = _this.state, svgContent = _b.svgContent, viewBoxVal = _b.viewBoxVal;
                if (svgContent && viewBoxVal) {
                    return _this.renderSvg(svgContent, viewBoxVal);
                }
            }
            else if (svgNodeStr && svgNodeStr.trim().substring(1, 4) === "svg") {
                return _this.renderIconFromStr();
            }
            return null;
        };
        _this.state = {
            svgContent: null,
            viewBoxVal: null,
        };
        return _this;
    }
    return IconSvg;
}(React__default.PureComponent));
exports.default = IconSvg;
});

var IconSvg = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = IconSvg_1.default;
});

var IconSvg$1 = /*@__PURE__*/getDefaultExportFromCjs(IconSvg);

var Icons = {
    dollarSignFlag: (createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", "aria-hidden": "true", "aria-labelledby": "dollarFlagSymbol", focusable: "false" },
        createElement("path", { className: "svg-base", d: "M23 1a3 3 0 013 3v26.7l-10-5.56L6 30.7V4a3 3 0 013-3zm-6 5h-2v2l-.176.005A3 3 0 0015 14h2a1 1 0 010 2h-4v2h2v2h2v-2l.176-.005A3 3 0 0017 12h-2a1 1 0 110-2h4V8h-2V6z" }))),
    dollarSignShield: (createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", "aria-hidden": "true", "aria-labelledby": "dollarShieldSymbol", focusable: "false" },
        createElement("path", { className: "svg-base", d: "M16 0l14.968 8.414v.632c0 9.686-3.968 15.385-7.296 18.459-3.623 3.349-7.237 4.374-7.389 4.416L16 32l-.283-.079c-.147-.04-14.685-4.276-14.685-22.875v-.632L16 0zm1.032 8.258h-2.064v2.065l-.176.004a3.097 3.097 0 00.176 6.19h2.064a1.032 1.032 0 110 2.064h-4.129v2.064h2.065v2.065h2.064v-2.065l.176-.005a3.097 3.097 0 00-.176-6.188h-2.064a1.032 1.032 0 110-2.065h4.129v-2.064h-2.065V8.258z" }))),
    chevronIcon: (createElement("svg", { "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", "aria-labelledby": "chevronIcon", focusable: "false" },
        createElement("title", { id: "chevronIcon" }, "Chevron Icon"),
        createElement("desc", { id: "" }),
        createElement("path", { className: "svg-base", d: "M8 11.05L2.65 5.7l.7-.7L8 9.63 12.65 5l.7.71z" }))),
    closeCircleOutline: (createElement("svg", { "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", "aria-labelledby": "closeCircleTitle", focusable: "false" },
        createElement("title", { id: "closeCircleTitle" }, "close icon"),
        createElement("desc", { id: "" }),
        createElement("path", { className: "svg-base", d: "M16 1a15 15 0 1015 15A15 15 0 0016 1zm0 28a13 13 0 1113-13 13 13 0 01-13 13zm0-14.41l4.24-4.25 1.42 1.42L17.41 16l4.25 4.24-1.42 1.42L16 17.41l-4.24 4.25-1.42-1.42L14.59 16l-4.25-4.24 1.42-1.42z" })))
};

var accentStripeBlue = "OfferBanner-module_accentStripeBlue__-5pej";
var accentStripePurple = "OfferBanner-module_accentStripePurple__BtCwk";
var accentStripeLime = "OfferBanner-module_accentStripeLime__qC5ti";
var dark = "OfferBanner-module_dark__MFs7K";
var panel = "OfferBanner-module_panel__miqx-";
var fanName = "OfferBanner-module_fanName__y7eyO";
var bannerIcon = "OfferBanner-module_bannerIcon__TgWJp";
var bannerText = "OfferBanner-module_bannerText__sSUAU";
var privateOfferType = "OfferBanner-module_privateOfferType__VEmxN";
var greeting = "OfferBanner-module_greeting__w8rHP";
var toggleText = "OfferBanner-module_toggleText__Oro89";
var drawerOuter = "OfferBanner-module_drawerOuter__N7niN";
var drawerInner = "OfferBanner-module_drawerInner__bj9Mr";
var offersHeading = "OfferBanner-module_offersHeading__x6od5";
var closeButton = "OfferBanner-module_closeButton__nJL3d";
var arrowIcon = "OfferBanner-module_arrowIcon__iILkq";
var black = "OfferBanner-module_black__3T-Eh";
var light = "OfferBanner-module_light__N2Vsz";
var signatureOfferType = "OfferBanner-module_signatureOfferType__2-e-8";
var bannerToggle = "OfferBanner-module_bannerToggle__1wIKx";
var firstnetOfferType = "OfferBanner-module_firstnetOfferType__U2ssl";
var panelMain = "OfferBanner-module_panelMain__WTq7P";
var offerImage = "OfferBanner-module_offerImage__uP1wk";
var offerCard = "OfferBanner-module_offerCard__e4JCV";
var legalText = "OfferBanner-module_legalText__W4MOk";
var hideAccentStripe = "OfferBanner-module_hideAccentStripe__O-FH4";
var firstNetImg = "OfferBanner-module_firstNetImg__i5U-i";
var expanded = "OfferBanner-module_expanded__kuUqM";
var checkMark = "OfferBanner-module_checkMark__msY0n";
var marginTopAuto = "OfferBanner-module_marginTopAuto__h-a1r";
var legalModalContent = "OfferBanner-module_legalModalContent__fW7He";
var privateBannerSubHeading = "OfferBanner-module_privateBannerSubHeading__rRCDU";
var expandedHeading = "OfferBanner-module_expandedHeading__FS68-";
var cardWrapper = "OfferBanner-module_cardWrapper__BrX1l";
var css_248z$2 = ".OfferBanner-module_accentStripeBlue__-5pej {\n  border-bottom-color: #009fdb; }\n\n.OfferBanner-module_accentStripePurple__BtCwk {\n  border-bottom-color: #af29bb; }\n\n.OfferBanner-module_accentStripeLime__qC5ti {\n  border-bottom-color: #91dc00; }\n\n.OfferBanner-module_dark__MFs7K {\n  background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_panel__miqx- {\n    color: #fff; }\n    .OfferBanner-module_dark__MFs7K .OfferBanner-module_panel__miqx-:focus {\n      outline: 0.1rem dashed #fff;\n      outline-offset: -.5rem; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_fanName__y7eyO {\n    border-color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_bannerIcon__TgWJp {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #dcdfe3; }\n  .OfferBanner-module_dark__MFs7K.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_closeButton__nJL3d {\n    background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #fff; }\n\n.OfferBanner-module_black__3T-Eh {\n  background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_panel__miqx- {\n    color: #fff; }\n    .OfferBanner-module_black__3T-Eh .OfferBanner-module_panel__miqx-:focus {\n      outline: 0.1rem dashed #fff;\n      outline-offset: -.5rem; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_fanName__y7eyO {\n    border-color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_bannerIcon__TgWJp {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #878C94; }\n  .OfferBanner-module_black__3T-Eh.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #878C94; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_closeButton__nJL3d {\n    background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #fff; }\n\n.OfferBanner-module_light__N2Vsz {\n  background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_panel__miqx-:focus {\n    outline: 0.1rem dashed #fff;\n    outline-offset: -.5rem; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_panel__miqx- {\n    color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_fanName__y7eyO {\n    border-color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_bannerIcon__TgWJp {\n    color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #878C94; }\n  .OfferBanner-module_light__N2Vsz.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #009fdb; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_closeButton__nJL3d {\n    background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #1d2329; }\n\n.OfferBanner-module_signatureOfferType__2-e-8 {\n  border-bottom-width: .6rem;\n  border-bottom-style: solid; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerToggle__1wIKx {\n    display: inline; }\n\n.OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_bannerToggle__1wIKx {\n  display: inline-block; }\n\n.OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq {\n  transform-origin: 50% 45%; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    vertical-align: bottom; }\n\n.OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq {\n  text-align: center;\n  transform-origin: 50% 47%;\n  vertical-align: middle; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq > svg {\n    vertical-align: middle; }\n\n.OfferBanner-module_privateOfferType__VEmxN {\n  border-bottom-width: .6rem;\n  border-bottom-style: solid; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_panelMain__WTq7P {\n    flex-wrap: nowrap;\n    height: auto;\n    flex: 1 100%; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_drawerInner__bj9Mr {\n    flex-wrap: wrap; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerImage__uP1wk {\n    max-height: 4.8rem;\n    max-width: 4.8rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV .OfferBanner-module_legalText__W4MOk + button {\n    vertical-align: baseline; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerToggle__1wIKx {\n    position: relative; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    bottom: 0; }\n\n.OfferBanner-module_hideAccentStripe__O-FH4 {\n  border-bottom-width: 0; }\n\n.OfferBanner-module_offersHeading__x6od5 {\n  display: block;\n  position: relative; }\n\n.OfferBanner-module_panel__miqx- {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  background-color: transparent;\n  width: 100%;\n  border: none;\n  text-align: left; }\n\n.OfferBanner-module_panelMain__WTq7P {\n  display: inline-flex;\n  position: relative;\n  align-items: flex-start;\n  height: auto; }\n\n.OfferBanner-module_bannerIcon__TgWJp {\n  margin-top: .4rem; }\n\n.OfferBanner-module_firstNetImg__i5U-i {\n  border-width: 0;\n  display: inline-block; }\n\n.OfferBanner-module_bannerText__sSUAU {\n  flex: 1 auto; }\n  .OfferBanner-module_bannerText__sSUAU label {\n    display: block; }\n\n.OfferBanner-module_expanded__kuUqM .OfferBanner-module_arrowIcon__iILkq {\n  transform: rotate(180deg); }\n\n.OfferBanner-module_toggleText__Oro89 {\n  vertical-align: baseline; }\n\n.OfferBanner-module_arrowIcon__iILkq {\n  transition: transform 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95) 0ms; }\n  .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 1.6rem;\n    width: 1.6rem; }\n\n.OfferBanner-module_drawerInner__bj9Mr ul:not(.OfferBanner-module_checkMark__msY0n) {\n  list-style: disc;\n  padding-left: 2rem; }\n  .OfferBanner-module_drawerInner__bj9Mr ul:not(.OfferBanner-module_checkMark__msY0n) ::marker {\n    font-size: 1.2rem; }\n\n.OfferBanner-module_drawerInner__bj9Mr .link-text {\n  color: #0057b8; }\n  .OfferBanner-module_drawerInner__bj9Mr .link-text:hover {\n    color: #009fdb; }\n\n.OfferBanner-module_drawerInner__bj9Mr button.type-sm {\n  margin-bottom: 0 !important; }\n\n.OfferBanner-module_checkMark__msY0n {\n  list-style-type: none;\n  -webkit-margin-start: 3.2rem;\n          margin-inline-start: 3.2rem; }\n  .OfferBanner-module_checkMark__msY0n > li:before {\n    content: '';\n    display: inline-block;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgaWQ9ImNoZWNrIj48cGF0aCBkPSJNMTEuMzMgMjYuNzVsLTEwLTEwIDEuNDItMS40MiA4LjYyIDguNjMgMTgtMTggMS40MiAxLjQxeiIvPjwvc3ZnPg==\");\n    list-style-type: none;\n    position: absolute;\n    margin-top: .6rem;\n    margin-left: -3.2rem;\n    width: 1.6rem;\n    height: 1.6rem; }\n\n.OfferBanner-module_offersHeading__x6od5 {\n  flex: 1 0 100%; }\n\n.OfferBanner-module_closeButton__nJL3d {\n  width: 100%;\n  display: flex;\n  background-color: #454B52; }\n  .OfferBanner-module_closeButton__nJL3d > div button {\n    color: #fff;\n    background-color: transparent;\n    border-width: 0;\n    border: none;\n    box-shadow: none; }\n    .OfferBanner-module_closeButton__nJL3d > div button svg {\n      fill: #fff; }\n    .OfferBanner-module_closeButton__nJL3d > div button:focus {\n      color: #fff;\n      outline: .1rem dotted currentColor !important; }\n\n.OfferBanner-module_marginTopAuto__h-a1r {\n  margin-top: auto; }\n\n.OfferBanner-module_legalModalContent__fW7He ul {\n  list-style: initial;\n  margin-left: 3rem; }\n\n.is-tabbing .OfferBanner-module_panel__miqx-:focus {\n  outline-color: transparent; }\n\n@media (max-width: 767px) {\n  .OfferBanner-module_bannerIcon__TgWJp {\n    width: 3.2rem;\n    height: 3.2rem;\n    flex: 0 0 3.2rem; }\n  .OfferBanner-module_panelMain__WTq7P {\n    flex: 1 100%; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 0;\n    padding-left: 0;\n    border-left-width: 0;\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: .8rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.2rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline-block;\n    line-height: 2.5rem !important; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_privateBannerSubHeading__rRCDU + .OfferBanner-module_bannerToggle__1wIKx .OfferBanner-module_toggleText__Oro89 {\n      font-size: 1.2rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    vertical-align: middle;\n    display: inline-block;\n    position: relative;\n    height: 1.6rem;\n    width: 1.6rem; }\n  .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 2.4rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    display: none; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute;\n    top: .8rem;\n    right: 2.4rem; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n      height: 2.4rem;\n      width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: .8rem;\n    border-top-right-radius: .8rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: .8rem;\n    border-bottom-right-radius: .8rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_firstNetImg__i5U-i {\n    width: 18.9rem;\n    height: 5.5rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 2.4rem;\n    margin-bottom: 2.4rem;\n    border-bottom: 0.1rem solid #979797; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      padding-top: 8px !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.5rem !important;\n    padding-right: 3.2rem; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label:nth-last-child(2) {\n      margin-top: .6rem;\n      margin-bottom: .6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    transform-origin: 50% 60%;\n    top: 1rem;\n    right: 3.2rem;\n    height: 1.6rem;\n    width: 1.6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    display: none; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    border-right: 0;\n    line-height: 2.2rem !important;\n    padding-right: 3.2rem;\n    display: inline-block; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: .8rem;\n    border-top-right-radius: .8rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: .8rem;\n    border-bottom-right-radius: .8rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 2.4rem;\n    margin-bottom: 2.4rem;\n    border-bottom: 0.1rem solid #979797; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li:not(:first-child) {\n      padding-top: 2.4rem !important; } }\n\n@media (min-width: 768px) {\n  .OfferBanner-module_bannerIcon__TgWJp {\n    width: 4.8rem;\n    height: 4.8rem;\n    flex: 0 0 4.8rem; }\n  .OfferBanner-module_panel__miqx- {\n    justify-content: space-between; }\n  .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline-block; }\n    .OfferBanner-module_privateBannerSubHeading__rRCDU + .OfferBanner-module_bannerToggle__1wIKx {\n      display: inline-block; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1.6rem;\n    padding-left: 1.6rem; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89:before {\n      content: '';\n      display: inline-block;\n      vertical-align: baseline;\n      position: relative;\n      height: 1.5rem;\n      width: .1rem;\n      border-left: 0.1rem solid #fff;\n      left: -1.6rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    width: 1.6rem;\n    height: 1.6rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    border-left: thin solid #fff; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_firstNetImg__i5U-i {\n    width: 20.6rem;\n    height: 6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1rem;\n    padding-left: 1rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label + .OfferBanner-module_bannerToggle__1wIKx .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 0;\n    padding-left: 0; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerToggle__1wIKx:not(:nth-child(2)) .OfferBanner-module_toggleText__Oro89 {\n    border-left: 0.1rem solid #878C94; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq {\n    width: 2.4rem;\n    height: 2.4rem; }\n  .OfferBanner-module_arrowIcon__iILkq {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle; } }\n\n@media (min-width: 1025px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 3rem !important;\n    letter-spacing: -.33px; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    line-height: 1.8rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1.2rem;\n    border-top-right-radius: 1.2rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1.2rem;\n    border-bottom-right-radius: 1.2rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-right: 3.2rem !important;\n    border-right: 0.1rem solid #979797;\n    margin-right: 3.2rem;\n    padding-top: 3.2rem;\n    letter-spacing: -.8px; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li {\n      line-height: 2.4rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 2.4rem;\n    padding-left: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1.2rem;\n    border-top-right-radius: 1.2rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1.2rem;\n    border-bottom-right-radius: 1.2rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-right: 3.2rem !important;\n    border-right: 0.1rem solid #979797;\n    margin-right: 3.2rem;\n    padding-top: 3.2rem;\n    letter-spacing: -.8px; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      line-height: 2.4rem;\n      padding-top: 8px !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    line-height: 3.2rem !important;\n    letter-spacing: -.33px; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: 1.2rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    justify-content: center; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :last-child {\n    flex: 8;\n    text-align: left;\n    word-break: break-word;\n    justify-content: flex-start; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :nth-last-child(2) {\n    flex: 3;\n    text-align: left;\n    margin-top: 0 !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    flex: 0 7.2rem;\n    justify-content: flex-start;\n    align-items: flex-start; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > * {\n    text-align: center; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l .type-lg {\n    letter-spacing: -.8px; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offersHeading__x6od5 {\n    letter-spacing: -.8px; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 3rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    width: 3rem;\n    height: 3rem; } }\n\n@media (max-width: 1024px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerInner__bj9Mr,\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerInner__bj9Mr {\n    flex-wrap: wrap; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68-,\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    border-bottom: 1px solid #979797;\n    padding-top: 0; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    flex-direction: column; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV :nth-last-child(3) {\n      justify-content: center; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.8rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 3.2rem;\n    margin-bottom: 3.2rem; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li:not(:first-child) {\n      padding-top: 3.2rem !important; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1.6rem;\n    padding-left: 1.6rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 3.2rem;\n    margin-bottom: 3.2rem; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      padding-top: 8px !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    line-height: 2.8rem !important;\n    display: inline; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: 1rem; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 2.4rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    width: 2.4rem;\n    height: 2.4rem; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .OfferBanner-module_panel__miqx-:focus, .OfferBanner-module_panel__miqx-:active {\n    outline: none !important;\n    position: relative; }\n    .OfferBanner-module_panel__miqx-:focus:before, .OfferBanner-module_panel__miqx-:active:before {\n      content: '';\n      display: block;\n      top: .5rem;\n      right: .5rem;\n      bottom: .5rem;\n      left: .5rem;\n      outline: 0.1rem dashed #fff;\n      position: absolute; } }\n\n@media all and (-ms-high-contrast: none) and (min-width: 1024px), (-ms-high-contrast: active) and (min-width: 1024px) {\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :last-child {\n    flex: 1 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(2) {\n    flex: 0 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    flex: 0 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type .OfferBanner-module_offerCard__e4JCV > :first-child {\n    width: 4.8rem;\n    height: 4.8rem;\n    margin-left: auto;\n    margin-right: auto; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type .OfferBanner-module_offerCard__e4JCV > :first-child .OfferBanner-module_offerImage__uP1wk {\n      width: 100%;\n      height: 100%; } }\n\n@media all and (-ms-high-contrast: none) and (min-width: 768px) and (max-width: 1024px), (-ms-high-contrast: active) and (min-width: 768px) and (max-width: 1024px) {\n  .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline !important; } }\n\n@media all and (-ms-high-contrast: none) and (max-width: 768px), (-ms-high-contrast: active) and (max-width: 768px) {\n  .OfferBanner-module_drawerInner__bj9Mr .OfferBanner-module_checkMark__msY0n {\n    margin-left: 3.2rem; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .OfferBanner-module_drawerOuter__N7niN .flex-1 {\n    flex: 1 auto; } }\n";
var OfferBanner_module = {"accentStripeBlue":"OfferBanner-module_accentStripeBlue__-5pej","accentStripePurple":"OfferBanner-module_accentStripePurple__BtCwk","accentStripeLime":"OfferBanner-module_accentStripeLime__qC5ti","dark":"OfferBanner-module_dark__MFs7K","panel":"OfferBanner-module_panel__miqx-","fanName":"OfferBanner-module_fanName__y7eyO","bannerIcon":"OfferBanner-module_bannerIcon__TgWJp","bannerText":"OfferBanner-module_bannerText__sSUAU","privateOfferType":"OfferBanner-module_privateOfferType__VEmxN","greeting":"OfferBanner-module_greeting__w8rHP","toggleText":"OfferBanner-module_toggleText__Oro89","drawerOuter":"OfferBanner-module_drawerOuter__N7niN","drawerInner":"OfferBanner-module_drawerInner__bj9Mr","offersHeading":"OfferBanner-module_offersHeading__x6od5","closeButton":"OfferBanner-module_closeButton__nJL3d","arrowIcon":"OfferBanner-module_arrowIcon__iILkq","black":"OfferBanner-module_black__3T-Eh","light":"OfferBanner-module_light__N2Vsz","signatureOfferType":"OfferBanner-module_signatureOfferType__2-e-8","bannerToggle":"OfferBanner-module_bannerToggle__1wIKx","firstnetOfferType":"OfferBanner-module_firstnetOfferType__U2ssl","panelMain":"OfferBanner-module_panelMain__WTq7P","offerImage":"OfferBanner-module_offerImage__uP1wk","offerCard":"OfferBanner-module_offerCard__e4JCV","legalText":"OfferBanner-module_legalText__W4MOk","hideAccentStripe":"OfferBanner-module_hideAccentStripe__O-FH4","firstNetImg":"OfferBanner-module_firstNetImg__i5U-i","expanded":"OfferBanner-module_expanded__kuUqM","checkMark":"OfferBanner-module_checkMark__msY0n","marginTopAuto":"OfferBanner-module_marginTopAuto__h-a1r","legalModalContent":"OfferBanner-module_legalModalContent__fW7He","privateBannerSubHeading":"OfferBanner-module_privateBannerSubHeading__rRCDU","expandedHeading":"OfferBanner-module_expandedHeading__FS68-","cardWrapper":"OfferBanner-module_cardWrapper__BrX1l"};
var stylesheet$1=".OfferBanner-module_accentStripeBlue__-5pej {\n  border-bottom-color: #009fdb; }\n\n.OfferBanner-module_accentStripePurple__BtCwk {\n  border-bottom-color: #af29bb; }\n\n.OfferBanner-module_accentStripeLime__qC5ti {\n  border-bottom-color: #91dc00; }\n\n.OfferBanner-module_dark__MFs7K {\n  background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_panel__miqx- {\n    color: #fff; }\n    .OfferBanner-module_dark__MFs7K .OfferBanner-module_panel__miqx-:focus {\n      outline: 0.1rem dashed #fff;\n      outline-offset: -.5rem; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_fanName__y7eyO {\n    border-color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_bannerIcon__TgWJp {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #dcdfe3; }\n  .OfferBanner-module_dark__MFs7K.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_closeButton__nJL3d {\n    background-color: #454B52; }\n  .OfferBanner-module_dark__MFs7K .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #fff; }\n\n.OfferBanner-module_black__3T-Eh {\n  background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_panel__miqx- {\n    color: #fff; }\n    .OfferBanner-module_black__3T-Eh .OfferBanner-module_panel__miqx-:focus {\n      outline: 0.1rem dashed #fff;\n      outline-offset: -.5rem; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_fanName__y7eyO {\n    border-color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_bannerIcon__TgWJp {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #878C94; }\n  .OfferBanner-module_black__3T-Eh.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #878C94; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_closeButton__nJL3d {\n    background-color: #1d2329; }\n  .OfferBanner-module_black__3T-Eh .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #fff; }\n\n.OfferBanner-module_light__N2Vsz {\n  background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_panel__miqx-:focus {\n    outline: 0.1rem dashed #fff;\n    outline-offset: -.5rem; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_panel__miqx- {\n    color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_fanName__y7eyO {\n    border-color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_bannerIcon__TgWJp {\n    color: #1d2329; }\n  .OfferBanner-module_light__N2Vsz.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_greeting__w8rHP {\n    color: #878C94; }\n  .OfferBanner-module_light__N2Vsz.OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    color: #009fdb; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_bannerText__sSUAU a {\n    color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_drawerOuter__N7niN {\n    background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_drawerInner__bj9Mr {\n    background-color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_offersHeading__x6od5 {\n    color: #fff; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_closeButton__nJL3d {\n    background-color: #999; }\n  .OfferBanner-module_light__N2Vsz .OfferBanner-module_arrowIcon__iILkq > svg {\n    fill: #1d2329; }\n\n.OfferBanner-module_signatureOfferType__2-e-8 {\n  border-bottom-width: .6rem;\n  border-bottom-style: solid; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerToggle__1wIKx {\n    display: inline; }\n\n.OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_bannerToggle__1wIKx {\n  display: inline-block; }\n\n.OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq {\n  transform-origin: 50% 45%; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    vertical-align: bottom; }\n\n.OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq {\n  text-align: center;\n  transform-origin: 50% 47%;\n  vertical-align: middle; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq > svg {\n    vertical-align: middle; }\n\n.OfferBanner-module_privateOfferType__VEmxN {\n  border-bottom-width: .6rem;\n  border-bottom-style: solid; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_panelMain__WTq7P {\n    flex-wrap: nowrap;\n    height: auto;\n    flex: 1 100%; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_drawerInner__bj9Mr {\n    flex-wrap: wrap; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerImage__uP1wk {\n    max-height: 4.8rem;\n    max-width: 4.8rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV .OfferBanner-module_legalText__W4MOk + button {\n    vertical-align: baseline; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerToggle__1wIKx {\n    position: relative; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    bottom: 0; }\n\n.OfferBanner-module_hideAccentStripe__O-FH4 {\n  border-bottom-width: 0; }\n\n.OfferBanner-module_offersHeading__x6od5 {\n  display: block;\n  position: relative; }\n\n.OfferBanner-module_panel__miqx- {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  background-color: transparent;\n  width: 100%;\n  border: none;\n  text-align: left; }\n\n.OfferBanner-module_panelMain__WTq7P {\n  display: inline-flex;\n  position: relative;\n  align-items: flex-start;\n  height: auto; }\n\n.OfferBanner-module_bannerIcon__TgWJp {\n  margin-top: .4rem; }\n\n.OfferBanner-module_firstNetImg__i5U-i {\n  border-width: 0;\n  display: inline-block; }\n\n.OfferBanner-module_bannerText__sSUAU {\n  flex: 1 auto; }\n  .OfferBanner-module_bannerText__sSUAU label {\n    display: block; }\n\n.OfferBanner-module_expanded__kuUqM .OfferBanner-module_arrowIcon__iILkq {\n  transform: rotate(180deg); }\n\n.OfferBanner-module_toggleText__Oro89 {\n  vertical-align: baseline; }\n\n.OfferBanner-module_arrowIcon__iILkq {\n  transition: transform 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95) 0ms; }\n  .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 1.6rem;\n    width: 1.6rem; }\n\n.OfferBanner-module_drawerInner__bj9Mr ul:not(.OfferBanner-module_checkMark__msY0n) {\n  list-style: disc;\n  padding-left: 2rem; }\n  .OfferBanner-module_drawerInner__bj9Mr ul:not(.OfferBanner-module_checkMark__msY0n) ::marker {\n    font-size: 1.2rem; }\n\n.OfferBanner-module_drawerInner__bj9Mr .link-text {\n  color: #0057b8; }\n  .OfferBanner-module_drawerInner__bj9Mr .link-text:hover {\n    color: #009fdb; }\n\n.OfferBanner-module_drawerInner__bj9Mr button.type-sm {\n  margin-bottom: 0 !important; }\n\n.OfferBanner-module_checkMark__msY0n {\n  list-style-type: none;\n  -webkit-margin-start: 3.2rem;\n          margin-inline-start: 3.2rem; }\n  .OfferBanner-module_checkMark__msY0n > li:before {\n    content: '';\n    display: inline-block;\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgaWQ9ImNoZWNrIj48cGF0aCBkPSJNMTEuMzMgMjYuNzVsLTEwLTEwIDEuNDItMS40MiA4LjYyIDguNjMgMTgtMTggMS40MiAxLjQxeiIvPjwvc3ZnPg==\");\n    list-style-type: none;\n    position: absolute;\n    margin-top: .6rem;\n    margin-left: -3.2rem;\n    width: 1.6rem;\n    height: 1.6rem; }\n\n.OfferBanner-module_offersHeading__x6od5 {\n  flex: 1 0 100%; }\n\n.OfferBanner-module_closeButton__nJL3d {\n  width: 100%;\n  display: flex;\n  background-color: #454B52; }\n  .OfferBanner-module_closeButton__nJL3d > div button {\n    color: #fff;\n    background-color: transparent;\n    border-width: 0;\n    border: none;\n    box-shadow: none; }\n    .OfferBanner-module_closeButton__nJL3d > div button svg {\n      fill: #fff; }\n    .OfferBanner-module_closeButton__nJL3d > div button:focus {\n      color: #fff;\n      outline: .1rem dotted currentColor !important; }\n\n.OfferBanner-module_marginTopAuto__h-a1r {\n  margin-top: auto; }\n\n.OfferBanner-module_legalModalContent__fW7He ul {\n  list-style: initial;\n  margin-left: 3rem; }\n\n.is-tabbing .OfferBanner-module_panel__miqx-:focus {\n  outline-color: transparent; }\n\n@media (max-width: 767px) {\n  .OfferBanner-module_bannerIcon__TgWJp {\n    width: 3.2rem;\n    height: 3.2rem;\n    flex: 0 0 3.2rem; }\n  .OfferBanner-module_panelMain__WTq7P {\n    flex: 1 100%; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 0;\n    padding-left: 0;\n    border-left-width: 0;\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: .8rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.2rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline-block;\n    line-height: 2.5rem !important; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_privateBannerSubHeading__rRCDU + .OfferBanner-module_bannerToggle__1wIKx .OfferBanner-module_toggleText__Oro89 {\n      font-size: 1.2rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    vertical-align: middle;\n    display: inline-block;\n    position: relative;\n    height: 1.6rem;\n    width: 1.6rem; }\n  .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 2.4rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    display: none; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute;\n    top: .8rem;\n    right: 2.4rem; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n      height: 2.4rem;\n      width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: .8rem;\n    border-top-right-radius: .8rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: .8rem;\n    border-bottom-right-radius: .8rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_firstNetImg__i5U-i {\n    width: 18.9rem;\n    height: 5.5rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 2.4rem;\n    margin-bottom: 2.4rem;\n    border-bottom: 0.1rem solid #979797; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      padding-top: 8px !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.5rem !important;\n    padding-right: 3.2rem; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label:nth-last-child(2) {\n      margin-top: .6rem;\n      margin-bottom: .6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_arrowIcon__iILkq {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    transform-origin: 50% 60%;\n    top: 1rem;\n    right: 3.2rem;\n    height: 1.6rem;\n    width: 1.6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    display: none; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    border-right: 0;\n    line-height: 2.2rem !important;\n    padding-right: 3.2rem;\n    display: inline-block; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: .8rem;\n    border-top-right-radius: .8rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: .8rem;\n    border-bottom-right-radius: .8rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 2.4rem;\n    margin-bottom: 2.4rem;\n    border-bottom: 0.1rem solid #979797; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li:not(:first-child) {\n      padding-top: 2.4rem !important; } }\n\n@media (min-width: 768px) {\n  .OfferBanner-module_bannerIcon__TgWJp {\n    width: 4.8rem;\n    height: 4.8rem;\n    flex: 0 0 4.8rem; }\n  .OfferBanner-module_panel__miqx- {\n    justify-content: space-between; }\n  .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline-block; }\n    .OfferBanner-module_privateBannerSubHeading__rRCDU + .OfferBanner-module_bannerToggle__1wIKx {\n      display: inline-block; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1.6rem;\n    padding-left: 1.6rem; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89:before {\n      content: '';\n      display: inline-block;\n      vertical-align: baseline;\n      position: relative;\n      height: 1.5rem;\n      width: .1rem;\n      border-left: 0.1rem solid #fff;\n      left: -1.6rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_arrowIcon__iILkq {\n    width: 1.6rem;\n    height: 1.6rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    border-left: thin solid #fff; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_firstNetImg__i5U-i {\n    width: 20.6rem;\n    height: 6rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1rem;\n    padding-left: 1rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label + .OfferBanner-module_bannerToggle__1wIKx .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 0;\n    padding-left: 0; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerToggle__1wIKx:not(:nth-child(2)) .OfferBanner-module_toggleText__Oro89 {\n    border-left: 0.1rem solid #878C94; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_arrowIcon__iILkq {\n    width: 2.4rem;\n    height: 2.4rem; }\n  .OfferBanner-module_arrowIcon__iILkq {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle; } }\n\n@media (min-width: 1025px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 3rem !important;\n    letter-spacing: -.33px; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    line-height: 1.8rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1.2rem;\n    border-top-right-radius: 1.2rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1.2rem;\n    border-bottom-right-radius: 1.2rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-right: 3.2rem !important;\n    border-right: 0.1rem solid #979797;\n    margin-right: 3.2rem;\n    padding-top: 3.2rem;\n    letter-spacing: -.8px; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li {\n      line-height: 2.4rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 2.4rem;\n    padding-left: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1.2rem;\n    border-top-right-radius: 1.2rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1.2rem;\n    border-bottom-right-radius: 1.2rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-right: 3.2rem !important;\n    border-right: 0.1rem solid #979797;\n    margin-right: 3.2rem;\n    padding-top: 3.2rem;\n    letter-spacing: -.8px; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      line-height: 2.4rem;\n      padding-top: 8px !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    line-height: 3.2rem !important;\n    letter-spacing: -.33px; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: 1.2rem; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    justify-content: center; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :last-child {\n    flex: 8;\n    text-align: left;\n    word-break: break-word;\n    justify-content: flex-start; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :nth-last-child(2) {\n    flex: 3;\n    text-align: left;\n    margin-top: 0 !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type > .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    flex: 0 7.2rem;\n    justify-content: flex-start;\n    align-items: flex-start; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > * {\n    text-align: center; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l .type-lg {\n    letter-spacing: -.8px; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offersHeading__x6od5 {\n    letter-spacing: -.8px; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 3rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    width: 3rem;\n    height: 3rem; } }\n\n@media (max-width: 1024px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerInner__bj9Mr,\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerInner__bj9Mr {\n    flex-wrap: wrap; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68-,\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    border-bottom: 1px solid #979797;\n    padding-top: 0; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    flex-direction: column; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV :nth-last-child(3) {\n      justify-content: center; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 2.8rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n    overflow: hidden; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_fanName__y7eyO {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_toggleText__Oro89 {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 3.2rem;\n    margin-bottom: 3.2rem; }\n    .OfferBanner-module_signatureOfferType__2-e-8 .OfferBanner-module_expandedHeading__FS68- + div li:not(:first-child) {\n      padding-top: 3.2rem !important; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_toggleText__Oro89 {\n    margin-left: 1.6rem;\n    padding-left: 1.6rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_arrowIcon__iILkq > svg {\n    height: 2.4rem;\n    width: 2.4rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :first-child {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_drawerOuter__N7niN > :last-child {\n    border-bottom-left-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n    overflow: hidden; }\n  .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- {\n    padding-bottom: 3.2rem;\n    margin-bottom: 3.2rem; }\n    .OfferBanner-module_firstnetOfferType__U2ssl .OfferBanner-module_expandedHeading__FS68- + div li {\n      padding-top: 8px !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    line-height: 2.8rem !important;\n    display: inline; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_bannerText__sSUAU > label {\n    line-height: 1.8rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_toggleText__Oro89 {\n    line-height: 2.4rem !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_offerCard__e4JCV {\n    border-radius: 1rem; }\n  .OfferBanner-module_closeButton__nJL3d button {\n    height: 2.4rem; }\n  .OfferBanner-module_closeButton__nJL3d svg {\n    width: 2.4rem;\n    height: 2.4rem; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .OfferBanner-module_panel__miqx-:focus, .OfferBanner-module_panel__miqx-:active {\n    outline: none !important;\n    position: relative; }\n    .OfferBanner-module_panel__miqx-:focus:before, .OfferBanner-module_panel__miqx-:active:before {\n      content: '';\n      display: block;\n      top: .5rem;\n      right: .5rem;\n      bottom: .5rem;\n      left: .5rem;\n      outline: 0.1rem dashed #fff;\n      position: absolute; } }\n\n@media all and (-ms-high-contrast: none) and (min-width: 1024px), (-ms-high-contrast: active) and (min-width: 1024px) {\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :last-child {\n    flex: 1 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(2) {\n    flex: 0 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:not(:only-of-type) .OfferBanner-module_offerCard__e4JCV > :nth-last-child(3) {\n    flex: 0 auto !important; }\n  .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type .OfferBanner-module_offerCard__e4JCV > :first-child {\n    width: 4.8rem;\n    height: 4.8rem;\n    margin-left: auto;\n    margin-right: auto; }\n    .OfferBanner-module_privateOfferType__VEmxN .OfferBanner-module_cardWrapper__BrX1l:only-of-type .OfferBanner-module_offerCard__e4JCV > :first-child .OfferBanner-module_offerImage__uP1wk {\n      width: 100%;\n      height: 100%; } }\n\n@media all and (-ms-high-contrast: none) and (min-width: 768px) and (max-width: 1024px), (-ms-high-contrast: active) and (min-width: 768px) and (max-width: 1024px) {\n  .OfferBanner-module_privateBannerSubHeading__rRCDU {\n    display: inline !important; } }\n\n@media all and (-ms-high-contrast: none) and (max-width: 768px), (-ms-high-contrast: active) and (max-width: 768px) {\n  .OfferBanner-module_drawerInner__bj9Mr .OfferBanner-module_checkMark__msY0n {\n    margin-left: 3.2rem; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .OfferBanner-module_drawerOuter__N7niN .flex-1 {\n    flex: 1 auto; } }\n";
styleInject(css_248z$2);

var styles$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    accentStripeBlue: accentStripeBlue,
    accentStripePurple: accentStripePurple,
    accentStripeLime: accentStripeLime,
    dark: dark,
    panel: panel,
    fanName: fanName,
    bannerIcon: bannerIcon,
    bannerText: bannerText,
    privateOfferType: privateOfferType,
    greeting: greeting,
    toggleText: toggleText,
    drawerOuter: drawerOuter,
    drawerInner: drawerInner,
    offersHeading: offersHeading,
    closeButton: closeButton,
    arrowIcon: arrowIcon,
    black: black,
    light: light,
    signatureOfferType: signatureOfferType,
    bannerToggle: bannerToggle,
    firstnetOfferType: firstnetOfferType,
    panelMain: panelMain,
    offerImage: offerImage,
    offerCard: offerCard,
    legalText: legalText,
    hideAccentStripe: hideAccentStripe,
    firstNetImg: firstNetImg,
    expanded: expanded,
    checkMark: checkMark,
    marginTopAuto: marginTopAuto,
    legalModalContent: legalModalContent,
    privateBannerSubHeading: privateBannerSubHeading,
    expandedHeading: expandedHeading,
    cardWrapper: cardWrapper,
    'default': OfferBanner_module,
    stylesheet: stylesheet$1
});

var constants = {
    ENDPOINT_CUSTOMER_OFFER: '/msapi/onlinesalesorch/v1/customeroffer',
    ENDPOINT_TIMEOUT: 20000,
};

var OfferAPIs = /** @class */ (function () {
    function OfferAPIs() {
    }
    /** Makes various network requests */
    OfferAPIs.makeRequest = function (url, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var complete = false;
                        var timeout = setTimeout(function () {
                            complete = true;
                            console.error("OfferBanner: Request timed out. URL: " + url);
                            reject('timed out');
                        }, constants.ENDPOINT_TIMEOUT);
                        fetch(url, __assign({ mode: 'cors', headers: { 'Content-Type': 'application/json' } }, config)).then(function (res) {
                            clearTimeout(timeout);
                            if (res && res.ok && !complete) {
                                return res.json();
                            }
                            reject(res.json());
                        }).then(function (res) {
                            resolve(res);
                        });
                    })];
            });
        });
    };
    /** get and return the offer content for banners */
    OfferAPIs.getOffersContent = function (Args, campaignIdHeader) {
        return __awaiter(this, void 0, void 0, function () {
            var params, urlParams, offer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        Args.offerType && params.push("offerType=" + Args.offerType);
                        Args.orderID && params.push("orderId=" + Args.orderID);
                        Args.pageID && params.push("pageId=" + Args.pageID);
                        Args.selectedCTN && params.push("selectedCTN=" + Args.selectedCTN);
                        urlParams = params.join('&');
                        return [4 /*yield*/, this.makeRequest((constants.ENDPOINT_CUSTOMER_OFFER +
                                ("?" + urlParams)), {
                                method: 'GET',
                                headers: __assign({ 'Content-Type': 'application/json' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                            }).then(function (res) {
                                console.log("OfferBanner: customeroffer API success.", res);
                                return Promise.resolve(res);
                            }).catch(function (err) {
                                console.error("OfferBannner: customeroffer API call failed.");
                                return Promise.reject(err);
                            })];
                    case 1:
                        offer = _a.sent();
                        return [2 /*return*/, offer];
                }
            });
        });
    };
    OfferAPIs.getLegalContent = function (url, campaignIdHeader) {
        return __awaiter(this, void 0, void 0, function () {
            var legal;
            return __generator(this, function (_a) {
                legal = this.makeRequest(url, {
                    method: 'GET',
                    headers: __assign({ 'Content-Type': 'application/json' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                })
                    .then(function (resp) {
                    return Promise.resolve(resp);
                })
                    .catch(function (err) {
                    return Promise.reject({ err: err });
                });
                return [2 /*return*/, legal];
            });
        });
    };
    OfferAPIs.getFirstNetContent = function (Args, campaignIdHeader) {
        return __awaiter(this, void 0, void 0, function () {
            var params, urlParams, offer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        Args.fnIntent && params.push("fnIntent=" + Args.fnIntent);
                        Args.pageID && params.push("pageId=" + Args.pageID);
                        urlParams = params.join('&');
                        console.log('urlparams', urlParams);
                        console.log('params', params);
                        return [4 /*yield*/, this.makeRequest((constants.ENDPOINT_CUSTOMER_OFFER +
                                ("?" + urlParams)), {
                                method: 'GET',
                                headers: __assign({ 'Content-Type': 'application/json' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                            }).then(function (res) {
                                console.log("FirstNet OfferBanner: customeroffer API success.", res);
                                return Promise.resolve(res);
                            }).catch(function (err) {
                                console.error("FirstNet OfferBannner: customeroffer API call failed.");
                                return Promise.reject(err);
                            })];
                    case 1:
                        offer = _a.sent();
                        return [2 /*return*/, offer];
                }
            });
        });
    };
    return OfferAPIs;
}());

var _this = undefined;
var OfferBannerTypes;
(function (OfferBannerTypes) {
    OfferBannerTypes["SIGNATURE_OFFER"] = "signature";
    OfferBannerTypes["PRIVATE_OFFER"] = "private";
    OfferBannerTypes["NATIONAL_OFFER"] = "national";
    OfferBannerTypes["NONCONTRACTUAL_OFFER"] = "nonContractual";
})(OfferBannerTypes || (OfferBannerTypes = {}));
var OfferBanner = function (props) {
    var _a = useState(props.expandOnLoad || false), expanded$1 = _a[0], setExpanded = _a[1];
    var _b = useState(false), showLegalModal = _b[0], setShowLegalModal = _b[1];
    var _c = useReducer(function (resp, val) { return val; }, { offers: [], specialOffers: [], banner: {} }), response = _c[0], setResponse = _c[1];
    var _d = useState(false), isFirstNet = _d[0], setFirstNetFlag = _d[1];
    var _e = useState(''), ResBannerType = _e[0], setResBannerType = _e[1];
    var _f = useState(true), showBannerDropdown = _f[0], setShowBannerDropdown = _f[1];
    var debug = useRef(false);
    var modalData = useRef(null);
    var bannerType = useRef('');
    var bannerIcon$1 = useRef(null);
    var FNLogoAlt = 'FirstNet®, Built with AT&T';
    var FNLogoLabel = 'FirstNet®, Built with AT&T';
    var banner;
    var offers = [];
    var specialOffers = [];
    var bannerContent;
    var offerType = props.offerType;
    var orderId = props.orderID ? encodeURIComponent(props.orderID) : undefined;
    var campaignIdHeader = props.campaignIdHeader || '';
    useEffect(function () {
        var _a;
        var firstNetIntent = getLocalStorage('fnIntend');
        var isFirstNet = firstNetIntent ? (firstNetIntent === "existing" || firstNetIntent === "true") : false;
        var GNSESS_ID = getCookie('GNSESS');
        var FANID = GNSESS_ID ? (((_a = JSON.parse(GNSESS_ID)) === null || _a === void 0 ? void 0 : _a.FANID) || false) : false;
        debug.current = props.debug === true;
        setFirstNetFlag(isFirstNet);
        var params = {};
        offerType && (params["offerType"] = encodeURIComponent(offerType));
        orderId && (params["orderID"] = encodeURIComponent(orderId));
        props.pageID && (params["pageID"] = encodeURIComponent(props.pageID));
        props.selectedCTN && (params["selectedCTN"] = encodeURIComponent(props.selectedCTN));
        if (props.fnIntent && banner) {
            var args = {};
            args["fnIntent"] = props.fnIntent;
            args["pageID"] = props.pageID;
            OfferAPIs.getFirstNetContent(args, campaignIdHeader).then(function (response) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                var isCaribbean = ((_b = (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.additionattributes) === null || _b === void 0 ? void 0 : _b.isCaribbean) === true;
                var stateCode = ((_d = (_c = response === null || response === void 0 ? void 0 : response.content) === null || _c === void 0 ? void 0 : _c.additionattributes) === null || _d === void 0 ? void 0 : _d.stateCode) || '';
                // store isCaribbean and stateCode in localstorage
                window.localStorage.setItem('isCaribbean', String(isCaribbean));
                window.localStorage.setItem('stateCode', String(stateCode));
                // Hide the dropdown for Caribbean
                if (isCaribbean)
                    setShowBannerDropdown(false);
                setResponse(response === null || response === void 0 ? void 0 : response.content);
                setResponse({ banner: (_e = response === null || response === void 0 ? void 0 : response.content) === null || _e === void 0 ? void 0 : _e.banner, offers: (_f = response === null || response === void 0 ? void 0 : response.content) === null || _f === void 0 ? void 0 : _f.offers, specialOffers: (_g = response === null || response === void 0 ? void 0 : response.content) === null || _g === void 0 ? void 0 : _g.specialOffers });
                bannerType.current = (_j = (_h = response === null || response === void 0 ? void 0 : response.content) === null || _h === void 0 ? void 0 : _h.banner) === null || _j === void 0 ? void 0 : _j.bannerType;
                setResBannerType((_l = (_k = response === null || response === void 0 ? void 0 : response.content) === null || _k === void 0 ? void 0 : _k.banner) === null || _l === void 0 ? void 0 : _l.bannerType);
            });
            debug.current && console.log('Offer Banner :: FN static banner :: ', response);
        }
        else {
            OfferAPIs.
                getOffersContent(params, campaignIdHeader)
                .then(function (apiResponse) {
                var _a, _b;
                debug.current && console.log('Offer Banner :: customeroffer response :: ', apiResponse);
                if (apiResponse && apiResponse.content &&
                    apiResponse.content.banner && apiResponse.content.banner.bannerType) {
                    var isSignature = apiResponse.content.banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER;
                    bannerType.current = (_b = (_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.content) === null || _a === void 0 ? void 0 : _a.banner) === null || _b === void 0 ? void 0 : _b.bannerType;
                    setResBannerType(apiResponse.content.banner.bannerType);
                    bannerIcon$1.current = (createElement("div", null, Icons.dollarSignFlag));
                    if (isSignature && !props.fnIntent) {
                        debug.current && console.log('Offer Banner :: customeroffer :: signature & not firstnet.');
                        try {
                            var iconurl = apiResponse.content.banner.icon;
                            if (iconurl) {
                                if (iconurl.search(/(.svg)$/) > -1 && (typeof fetch !== 'undefined')) {
                                    bannerIcon$1.current = (createElement(IconSvg$1, { svgUrl: iconurl, ariaHidden: true }));
                                    debug.current && console.log('Offer Banner :: customeroffer :: svg icon & fetch is ready.');
                                }
                                else {
                                    bannerIcon$1.current = (createElement("img", { src: iconurl, "aria-hidden": true }));
                                    debug.current && console.log('Offer Banner :: customeroffer :: not svg or fetch not ready.');
                                }
                            }
                        }
                        catch (exception) {
                            console.error('Offer Banner :: customeroffer try-catch exception :: ', exception);
                        }
                    }
                    setResponse(apiResponse.content);
                    debug.current && console.log('Offer Banner :: customeroffer response set: ', response);
                }
            })
                .catch(function (err) {
                console.error('Offer Banner :: customeroffer api error :: ', err);
            });
        }
    }, []);
    useEffect(function () {
        if (props.onBannerLoadComplete && response && response.offers) {
            if (bannerType.current === '') {
                bannerType.current = response.banner.bannerType;
                setResBannerType(response.banner.bannerType);
            }
            if ((bannerType.current === OfferBannerTypes.SIGNATURE_OFFER ||
                props.fnIntent) && response.offers) {
                debug.current && console.log('Offer Banner :: useEffect - onBannerLoadComplete');
                props.onBannerLoadComplete(bannerType.current, response.offers.filter(function (x) { return x.offerHeading; }));
            }
            else if (bannerType.current === OfferBannerTypes.PRIVATE_OFFER && response.offers) {
                props.onBannerLoadComplete(bannerType.current, response.offers);
            }
        }
    }, [response]);
    var getLocalStorage = function (key) {
        return localStorage.getItem(key);
    };
    var getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2)
            return parts.pop().split(';').shift();
    };
    var renderLegalModal = function (legal, e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            modalData.current = legal;
            setShowLegalModal(true);
            if (props.onLegalModalLoadComplete) {
                props.onLegalModalLoadComplete(bannerType.current);
            }
            return [2 /*return*/];
        });
    }); };
    var fetchLongLegalModalContent = function (e, offer) {
        var legalContent = offer.longLegalText;
        var evt = {};
        Object.assign(evt, e);
        // need to figure out the correct structure
        if (offer.longLegalUrl) {
            OfferAPIs.getLegalContent(offer.longLegalUrl, campaignIdHeader)
                .then(function (resp) {
                var filename = offer.longLegalUrl.split('/').pop().split('.').shift();
                if (!!filename.length &&
                    resp["idp-cms-feed"] &&
                    resp["idp-cms-feed"][filename] &&
                    resp["idp-cms-feed"][filename]["master"] &&
                    resp["idp-cms-feed"][filename]["master"]["legalLongPath"] &&
                    !!resp["idp-cms-feed"][filename]["master"]["legalLongPath"].length) {
                    var legalText_1 = '';
                    resp["idp-cms-feed"][filename]["master"]["legalLongPath"].map(function (legal) {
                        if (legal["master"] && legal["master"]["legalText"]) {
                            legalText_1 += legal["master"] && legal["master"]["legalText"];
                        }
                    });
                    renderLegalModal(legalText_1);
                }
            })
                .catch(function (err) {
                console.log('Fetch legal modal content:: ', err);
                // default legal content or error message?
            });
        }
        else if (legalContent) {
            renderLegalModal(legalContent);
        }
    };
    var closeLegalModal = function () {
        setShowLegalModal(false);
        if (props.legalModalCloseIconClick) {
            props.legalModalCloseIconClick(bannerType.current);
        }
    };
    var legalModal = function () {
        return (createElement(SimpleModal$3, { accessibilityTitle: "Legal Modal", show: showLegalModal, closeHidden: false, close: closeLegalModal, sizing: "normal", size: "large", testId: banner ? (banner.id + '_modal') : '_modal', disableOnFocus: true },
            createElement("div", { className: "pad-md", dangerouslySetInnerHTML: { __html: modalData.current } })));
    };
    if (response) {
        banner = response.banner;
        offers = response.offers || [];
        specialOffers = response.specialOffers || [];
    }
    var renderOfferBanner = function () {
        var labelClasses, headingClasses, toggleTextClasses, panelSpacing, outerDrawerSpacing, closeBtnSpacing;
        if (banner && (offers || specialOffers) && bannerType.current) {
            if (bannerType.current === OfferBannerTypes.SIGNATURE_OFFER || props.fnIntent) {
                var offerListContent = void 0;
                var specialOfferContent = void 0;
                var legalModalContent_1 = '';
                var legalShortText_1;
                var offersSubHeading = banner.offersSubHeading ? banner.offersSubHeading : '';
                var specialOffersSubHeading = banner.specialOffersSubHeading ? banner.specialOffersSubHeading : '';
                var numOfItems_1 = props.numberOfBulletsToDisplay;
                if (!!offers.length || !!specialOffers.length) {
                    specialOfferContent = specialOffers.map(function (specialOffer, index) {
                        if (specialOffer.offerHeading && (numOfItems_1 ? index < numOfItems_1 : true)) {
                            return (createElement("li", { key: "list_item_" + specialOffer.offerID, className: "type-sm font-medium mar-b-none rwd", dangerouslySetInnerHTML: { __html: specialOffer.offerHeading } }));
                        }
                    });
                    offerListContent = offers.map(function (offer, index) {
                        if (offer.longLegalText) {
                            legalModalContent_1 += '<br />' + offer.longLegalText + '<br />';
                        }
                        legalShortText_1 = legalShortText_1 || offer.legalShortText;
                        if (offer.offerHeading && (numOfItems_1 ? index < numOfItems_1 : true)) {
                            return (createElement("li", { key: "list_item_" + offer.offerID, className: "type-sm font-medium mar-b-none rwd", dangerouslySetInnerHTML: { __html: offer.offerHeading } }));
                        }
                    });
                    if (!!legalModalContent_1.length) {
                        legalModalContent_1 = '<div class=' + legalModalContent + ' id=\"legalModalContent\">' + legalModalContent_1 + '</div>';
                    }
                }
                bannerContent = (createElement(Fragment, null,
                    createElement("div", { className: drawerInner + " flex justify-center grid-col-10 grid-col-12-md grid-col-12-sm pad-lg-lg pad-xl-md pad-xl-sm mar-t-xs rwd" },
                        (banner && banner.expandedOffer) ?
                            createElement("div", { className: expandedHeading + " flex flex-items-center font-medium type-lg grid-col-4 grid-col-12-md grid-col-12-sm pad-none-lg pad-b-lg-md pad-b-lg-sm pad-r-none pad-l-none rwd" },
                                createElement("div", null, banner.expandedOffer)) : null,
                        createElement("div", { className: "grid-col-7 grid-col-12-md grid-col-12-sm pad-none" },
                            createElement("h1", { className: "pad-t-sm type-md font-medium mar-b-none rwd" }, specialOffersSubHeading),
                            specialOfferContent && !!specialOfferContent.length ?
                                (createElement("ul", null, specialOfferContent)) : null,
                            createElement("h1", { className: "pad-t-sm type-md font-medium mar-b-none rwd" }, offersSubHeading),
                            offerListContent && !!offerListContent.length ?
                                (createElement("ul", null, offerListContent)) : null,
                            legalShortText_1 ?
                                (createElement("div", { className: "mar-t-sm-lg mar-t-xs-sm mar-t-md-md mar-b-none rwd" },
                                    createElement("button", { className: "link-text3 border-none bg-transparent type-sm font-medium", onClick: function (e) {
                                            if (props.legalModalLinkClick) {
                                                props.legalModalLinkClick(bannerType.current, e.currentTarget.innerHTML);
                                            }
                                            return fetchLongLegalModalContent.apply(_this, [e, { longLegalText: legalModalContent_1 }]);
                                        } }, legalShortText_1))) : null))));
                labelClasses = 'font-medium type-md';
                headingClasses = 'font-regular type-sm';
                toggleTextClasses = 'type-sm';
                panelSpacing = 'pad-l-md-lg pad-r-md-lg pad-l-lg-md pad-r-lg-md pad-l-lg-sm pad-r-lg-sm';
                panelSpacing += props.fnIntent ? ' pad-t-xxs pad-b-xxs' : ' pad-t-sm pad-b-sm';
                outerDrawerSpacing = 'pad-t-sm pad-l-md-lg pad-r-md-lg pad-r-lg-md pad-l-lg-md pad-l-lg-sm pad-r-lg-sm';
                closeBtnSpacing = 'mar-t-xs-lg mar-b-xs-lg mar-t-xxs-md mar-b-xxs-md mar-t-none-sm mar-b-none-sm';
            }
            else if (bannerType.current === OfferBannerTypes.PRIVATE_OFFER) {
                var cardWrapperClasses_1 = '', cardClass_1 = '';
                if (offers) {
                    if (offers.length === 1) {
                        cardWrapperClasses_1 = "grid-col-12";
                    }
                    else if (offers.length === 2) {
                        cardWrapperClasses_1 = "grid-col-6 grid-col-12-sm";
                        cardClass_1 = 'flex-column ';
                    }
                    else if (offers.length > 2) {
                        cardWrapperClasses_1 = "grid-col-4 grid-col-6-md grid-col-12-sm";
                        cardClass_1 = 'flex-column ';
                    }
                }
                bannerContent = (createElement(Fragment, null,
                    banner.expandedOffer ?
                        (createElement("p", { className: offersHeading + " font-medium type-lg pad-l-xs pad-r-xs pad-b-md rwd" }, banner.expandedOffer)) : null,
                    offers && !!offers.length && offers.map(function (offer, index) { return (createElement("div", { className: cardWrapper + " " + cardWrapperClasses_1, key: offer.offerID },
                        createElement("div", { className: offerCard + " flex " + cardClass_1 + "bg-ui-white word-wrap text-center pad-md rwd height-full rel" },
                            createElement("div", { className: "inline-flex" }, offer.imgPath.search(/(.svg)$/ig) > -1 && (typeof fetch !== 'undefined') ?
                                createElement(IconSvg$1, { svgUrl: offer.imgPath, ariaHidden: true, className: "" + offerImage }) :
                                createElement("img", { className: "" + offerImage, src: offer.imgPath, alt: offer.imgAltText })),
                            createElement("div", { className: "font-medium type-lg mar-t-xs pad-r-md-lg rwd", dangerouslySetInnerHTML: { __html: offer.offerHeading } }),
                            createElement("div", { className: "flex flex-column justify-between flex-1" },
                                createElement("div", { className: "font-medium type-sm mar-t-xxs rwd", dangerouslySetInnerHTML: { __html: offer.offerDescription } }),
                                offer.legalShortText && offer.longLegalUrl ?
                                    (createElement("div", { className: marginTopAuto + " mar-t-xs rwd mar-b-none" },
                                        offer.legalText ?
                                            createElement("span", { className: legalText + " type-xxs" },
                                                offer.legalText,
                                                "\u00A0") : null,
                                        createElement("button", { className: "link-text3 border-none bg-transparent type-xxs", onClick: function (e) {
                                                if (props.legalModalLinkClick) {
                                                    props.legalModalLinkClick(bannerType.current, e.currentTarget.innerHTML, index, offer.offerID, offer.offerHeading);
                                                }
                                                return fetchLongLegalModalContent.apply(_this, [e, offer]);
                                            } }, offer.legalShortText))) : null)))); })));
                labelClasses = 'font-medium type-sm';
                headingClasses = 'font-medium type-md';
                toggleTextClasses = 'font-medium type-sm inline-block mar-t-xxs-sm mar-b-xxs-sm';
                panelSpacing = 'pad-t-sm-sm pad-b-sm-sm pad-t-xs-md pad-b-xs-md pad-t-sm-lg pad-b-sm-lg pad-l-md-lg pad-r-md-lg pad-l-lg-md pad-r-lg-md pad-l-lg-sm pad-r-lg-sm';
                outerDrawerSpacing = 'pad-t-sm pad-l-xs-lg pad-r-xs-lg pad-r-sm-md pad-l-sm-md pad-l-sm-sm pad-r-sm-sm';
                closeBtnSpacing = 'pad-t-none';
            }
        }
        var hideAccentStripe$1 = (props && (props.hideAccentStripe === true))
            ? hideAccentStripe : null;
        var accentStripeColor = !hideAccentStripe$1 ? (props && props.accentStripeColor
            ? styles$1['accentStripe' + props.accentStripeColor] : accentStripeBlue) : null;
        var bannerTheme = !props.fnIntent ? props && props.theme ? styles$1[props.theme] : dark : black;
        debug.current && console.log('Offer Banner :: renderOfferBanner - return - ', response);
        return (createElement(Fragment, null,
            (banner && (offers || specialOffers) && bannerType.current) &&
                (createElement("div", { className: bannerTheme + " " + styles$1[props.fnIntent ? 'firstnetOfferType' : bannerType.current + 'OfferType'] + " " + (accentStripeColor || hideAccentStripe$1) + " width-full rwd", id: props.id },
                    createElement("button", { "aria-labelledby": banner ? (banner.id + '_heading') : 'banner_heading', "aria-expanded": expanded$1, id: banner ? (banner.id + '_heading') : 'banner_heading', "aria-controls": banner ? (banner.id + '_content') : 'banner_content', onClick: function () {
                            setExpanded(!expanded$1);
                            if (props.bannerPanelOnClick) {
                                props.bannerPanelOnClick(bannerType.current, !expanded$1, offers);
                            }
                        }, className: "" + panel + (expanded$1 ? ' ' + expanded : '') },
                        createElement("div", { className: panelMain + " container " + panelSpacing + " rwd" },
                            (banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER) && bannerIcon$1.current && !props.fnIntent ?
                                createElement("div", { className: bannerIcon + " mar-r-xxs", "aria-hidden": "true" }, bannerIcon$1.current) : null,
                            createElement("div", { className: "" + bannerText + (props.fnIntent ? ' flex flex-items-bottom' : '') },
                                props.fnIntent ?
                                    createElement("div", { className: "" + firstNetImg },
                                        createElement("img", { src: banner.icon, alt: FNLogoAlt, "aria-label": FNLogoLabel })) :
                                    createElement(Fragment, null,
                                        createElement("label", { className: greeting + " " + labelClasses + " mar-b-none" },
                                            banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER ? banner.heading : null,
                                            (banner.bannerType === OfferBannerTypes.PRIVATE_OFFER && banner.subHeading) ? banner.subHeading : null),
                                        (banner.subHeading || banner.bannerType === OfferBannerTypes.PRIVATE_OFFER) ?
                                            (createElement("span", { className: "" + (bannerType.current === OfferBannerTypes.PRIVATE_OFFER ? privateBannerSubHeading + ' ' : '') + fanName + " " + headingClasses + " mar-b-none" },
                                                banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER ? banner.subHeading : null,
                                                banner.bannerType === OfferBannerTypes.PRIVATE_OFFER ? banner.heading : null)) : null),
                                showBannerDropdown ? (createElement("div", { className: "" + bannerToggle + (props.fnIntent ? ' flex-self-bottom mar-b-xxxs' : '') },
                                    banner.collapsedOffer &&
                                        (createElement("span", { className: toggleText + " " + toggleTextClasses }, banner.collapsedOffer)),
                                    createElement("span", { className: "mar-l-xxs " + arrowIcon }, Icons.chevronIcon))) : null))),
                    showBannerDropdown ? (createElement(Collapse$1, { expanded: expanded$1 },
                        createElement("div", { id: banner ? (banner.id + '_content') : 'banner_content', className: drawerOuter + " flex flex-wrap " + (banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER ? "justify-start " : '') + "container " + outerDrawerSpacing + " rwd" }, bannerContent),
                        createElement("div", { className: styles$1[props.theme] + " " + closeButton + " container" },
                            createElement("div", { className: ((banner.bannerType === OfferBannerTypes.SIGNATURE_OFFER || props.fnIntent) ?
                                    "grid-col-10" :
                                    "grid-col-12 pad-t-none") + " flex justify-center grid-col-12-md grid-col-12-sm" },
                                createElement("button", { "aria-label": "close button", "aria-expanded": expanded$1, className: closeBtnSpacing + " rwd", onClick: function () {
                                        setExpanded(false);
                                        if (props.bannerCloseIconClick) {
                                            props.bannerCloseIconClick(bannerType.current);
                                        }
                                    } }, Icons.closeCircleOutline))))) : null)),
            legalModal()));
    };
    return (createElement(Fragment, null, renderOfferBanner()));
};

export { AccentStripeColor, OfferBanner, OfferType, PageID, Theme };
//# sourceMappingURL=offer-banner.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sales/offer-banner/dist/offer-banner.es.js
// module id = 944
// module chunks = 8